(function () {
  'use strict';

  function premierChamp(panneau) {
    return panneau.querySelector('input:not([type="hidden"]), select, textarea');
  }

  function poser(bloc) {
    var bouton = bloc.querySelector('[data-cm-devis-bouton]');
    var panneau = bloc.querySelector('[data-cm-devis-panneau]');
    if (!bouton || !panneau) return;

    var envoye = !!panneau.querySelector('[data-cm-devis-envoye]');

    function afficher(ouvert, donnerLeFocus) {
      panneau.setAttribute('data-ouvert', ouvert ? 'true' : 'false');
      bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      var libelle = ouvert
        ? bouton.getAttribute('data-texte-ouvert')
        : bouton.getAttribute('data-texte-ferme');
      if (libelle) bouton.textContent = libelle;
      if (ouvert && donnerLeFocus) {
        var champ = premierChamp(panneau);
        if (champ) champ.focus({ preventScroll: true });
      }
    }

    if (envoye) {

      afficher(true, false);
      panneau.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {

      var transition = panneau.style.transition;
      panneau.style.transition = 'none';
      afficher(false, false);
      requestAnimationFrame(function () {
        panneau.style.transition = transition;
      });
    }

    bouton.addEventListener('click', function () {
      var ouvert = bouton.getAttribute('aria-expanded') === 'true';
      afficher(!ouvert, !ouvert);
    });
  }

  function demarrer() {
    var blocs = document.querySelectorAll('.cm-devis');
    for (var i = 0; i < blocs.length; i++) poser(blocs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
